import { Stack } from '@mui/material';
import { CheckboxInput } from 'Components';
import { DocumentsContext } from 'Context/DocumentsContext';
import { DOCUMENTS_REDUCER_CASE } from 'Enum/documents';
import { ResetFilterButtons } from 'Modules/Suppliers/SuppliersMain/ResultsPages/Header/DynamicAdvancedFilter/ResetFilterButtons';
import { useContext } from 'react';

interface ISubjectType {
  options: string[];
}

export const SubjectType = ({ options }: ISubjectType) => {
  const { filter, dispatchDocuments, advancedFilterActivationHandler } =
    useContext(DocumentsContext);

  const filterSubjectTypeHandler = (option: string) => {
    const optionWithoutAmount = option.split(' (')[0];

    const updatedFilter = { ...filter };

    const index = updatedFilter.subjectsTypes.indexOf(optionWithoutAmount);
    if (index < 0) updatedFilter.subjectsTypes.push(optionWithoutAmount);
    else updatedFilter.subjectsTypes.splice(index, 1);

    advancedFilterActivationHandler(updatedFilter);
    dispatchDocuments({
      type: DOCUMENTS_REDUCER_CASE.FILTER,
      payload: {
        value: { filter: updatedFilter },
      },
    });
  };

  const resetSubjectFilterHandler = () => {
    const updatedFilter = { ...filter, subjectsTypes: [] };
    advancedFilterActivationHandler(updatedFilter);
    dispatchDocuments({
      type: DOCUMENTS_REDUCER_CASE.FILTER,
      payload: {
        value: { filter: updatedFilter },
      },
    });
  };

  return (
    <Stack
      sx={{
        pb: '50px',
      }}
      tabIndex={-1}
    >
      {options.map((option: string, index: number) => {
        return (
          <CheckboxInput
            key={index}
            checked={filter.subjectsTypes.includes(option.split(' (')[0])}
            label={option}
            onChange={() => filterSubjectTypeHandler(option)}
            containerStyle={{
              '.MuiCheckbox-root': {
                m: '8px 0',
                p: '0 5px 0 16px',
              },
            }}
            textSx={{
              fontWeight: false ? '600 !important' : undefined,
              ':hover': {
                fontWeight: 600,
              },
            }}
          />
        );
      })}
      <ResetFilterButtons
        resetCallback={resetSubjectFilterHandler}
        sx={{
          pl: '8px',
          justifyContent: 'flex-start',
        }}
      />
    </Stack>
  );
};
